<template>
	<div>
		<b-button variant="outline-warning" @click="fetchPayments" class="mb-3 mr-1">
			<md-icon icon="update"/>
		</b-button>
		<b-button variant="outline-primary" @click="openFormPayment" class="mb-3">
			<md-icon icon="add_box"/>
			{{ $t('payments.newPayment') }}
		</b-button>
		<b-overlay :show="loading" no-wrap rounded></b-overlay>
		<b-table stacked="lg" striped hover :fields="modelColumns" :items="itemsPayments" :show-empty="true" :empty-text="$t('payments.noPayment')">
			<template #cell(show_details)="row">
				<b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
					{{ $t('payments.showDetails') }}
				</b-form-checkbox>
			</template>

			<template #cell(total)="row">
				{{ $root.formatLblPrice(row.item.total, row.item.currency) }}
			</template>
			<template #cell(totalPaid)="row">
				<label> {{ $root.formatLblPrice(row.item.totalPaid, row.item.currency) }}</label>
				<b-progress variant="danger" :striped="'striped'" v-if="(getProgress(row)==0)">
					<b-progress-bar :value="100" label="0%"></b-progress-bar>
				</b-progress>
				<b-progress v-else :variant="'success'" :striped="true" show-progress animated>
					<b-progress-bar :value=" getProgress(row)"
									:label="`${getProgress(row).toFixed(2)}%`"></b-progress-bar>
				</b-progress>
			</template>
			<template #cell(status)="row">
				<b-badge href="#" :variant="row.item._rowVariant">{{ row.item.statusLabel }}</b-badge>
			</template>
			<template #row-details="row">
				<b-card>
					<b-tabs content-class="mt-3" align="center">
						<b-tab :title="$t('payments.transactions')" active>
							<b-row class="mb-2">
								<b-col>
									<paymentTransaction :payment="row.item"></paymentTransaction>
								</b-col>
							</b-row>
						</b-tab>
						<b-tab :title="$t('payments.ridesToPay')">
							<template #title>
								{{ $t('payments.ridesToPay') }}
								<b-badge variant="success">{{ row.item.transportServices.length }}</b-badge>
							</template>

							<rides-in-payment :payment="row.item"></rides-in-payment>
						</b-tab>
					</b-tabs>

					<b-row class="justify-content-end">
						<b-button class="mr-2 btn-sm" variant="danger" @click="cancelPayment(row.item.id)" v-if="row.item.status == 'pending'">
							<md-icon icon="request_quote"></md-icon>
							{{ $t('payments.cancel') }}
						</b-button>

						<b-button class="mr-2 btn-sm" variant="warning" @click="seeNotifications(row.item.id)">
							<md-icon icon="notifications_active"></md-icon>
							{{ $t('payments.notifications') }}
						</b-button>

						<b-dropdown right text="Link" variant="success" v-if="row.item.status == 'pending'">
							<b-dropdown-item @click="copyLinkPayment('linkPayment'+row.item.id)">{{ $t('payments.copy') }}
							</b-dropdown-item>
							<b-dropdown-item :href="row.item.paymentUrl" target="_blank">{{ $t('payments.goToLink') }}
							</b-dropdown-item>
							<b-form-input size="sm" readonly :ref="'linkPayment'+row.item.id" type="text" :value="row.item.paymentUrl"
							/>
						</b-dropdown>
					</b-row>

					<b-button size="sm" @click="row.toggleDetails">{{ $t('payments.hideDetails') }}</b-button>
				</b-card>
			</template>
		</b-table>

		<b-modal
			scrollable
			no-fade
			ok-only
			:title="$t('payments.paymentForm')"
			id="modal-form-payment"
			ref="modal-form-payment"
			size="xl"
			body-class="position-static"
			hide-footer
			no-close-on-backdrop
			v-model="showFormPayment"
		>
			<form-payment :modelId="modelId" @done="formDone"></form-payment>
		</b-modal>
		<b-modal
			scrollable
			no-fade
			ok-only
			:title="$t('payments.notifications')"
			id="modal-payment-notifications"
			ref="modal-payment-notifications"
			size="xl"
			body-class="position-static"
			hide-footer
			no-close-on-backdrop
		>
			<mail-history
				:filters="notifications.filters"
				:selected="notifications.selected"
			/>

		</b-modal>
	</div>
</template>

<script>
import {mapState} from "vuex";
import api from '../../../../api.js'
import paymentTransaction from '../payments/PaymentTransaction.vue'
import RidesInPayment from '../payments/TransportServicesInPayment.vue'
import formPayment from "../payments/FormPayment.vue"
import MailHistory from "./TabNotifications";

export default {
	components: {
		paymentTransaction,
		formPayment,
		MailHistory,
		RidesInPayment
	},
	props: {
		modelId: {
			type: Number,
			required: false,
			default: -1
		}
	},
	data() {
		return {
			data: [],
			loading: true,
			modelColumns: [
				{key: 'show_details', label: this.$t('payments.details')},
				{key: 'id', label: this.$t('payments.id')},
				{key: 'currency', label: this.$t('payments.currency')},
				{key: 'total', label: this.$t('payments.totalPayable'), class: 'text-right'},
				{key: 'totalPaid', label: this.$t('payments.totalPaid'), class: 'text-right'},
				{key: 'creationDatetime', label: this.$t('payments.created')},
				{key: 'expiresAt', label: this.$t('payments.expiration')},
				{key: 'user', label: this.$t('payments.user')},
				{key: 'status', label: this.$t('payments.status')},
			],
			payments: [],
			showFormPayment: false,
			showModalPaymentsNotifications: false,
			notifications: {
				filters: {}
			}
		}
	},
	methods: {
		cancelPayment(paymentId) {
			this.$bvModal.msgBoxConfirm(`${this.$t('payments.sureCancelPayment', {paymentId: paymentId})}`, {
				title: this.$t('payments.confirm'),
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: this.$t('payments.yes'),
				cancelTitle: this.$t('payments.cancel'),
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
				.then(value => {
					if (value) {
						api(this).post(`/reservations/${this.modelId}/payment/${paymentId}`)
							.then((res) => {
								this.$root.showAlert(this.$t('payments.paymentCanceled') + res.data.id)
								this.fetchPayments();
							})
							.catch(this.$root.handleRequestError)
							.finally(() => {
								this.loading = false;
							})
					}
				})
				.catch(err => {
					console.log(err)
				})

		},
		seeNotifications(paymentId) {
			this.notifications.filters = {only: {objectName: "Payments", objectIds: [paymentId]}}
			this.notifications.selected = {templateCode: "paymentLink", objectId: paymentId}
			this.$root.$emit(
				"bv::show::modal",
				"modal-payment-notifications",
				event.target
			);
		},
		fetchPayments() {
			if (this.modelId !== -1) {
				this.loading = true;
				this.payments = [];
				api(this).get(`reservations/${this.modelId}/payments`).then(res => {
					this.payments = res.data.payments;
					this.loading = false;
				}).catch(this.$root.handleRequestError);
			}
		},
		getProgress(row) {
			let totalPaid = row.item.totalPaid;
			let totalToPay = row.item.total;
			return ((totalPaid * 100) / totalToPay)
		},
		openFormPayment() {
			this.$refs['modal-form-payment'].show()
		},
		closeFormPayment() {
			this.$refs['modal-form-payment'].hide()
		},
		copyLinkPayment(ref) {
			let field = this.$refs[ref];
			field.select();
			field.setSelectionRange(0, 999999);
			window.document.execCommand('copy');
			this.$root.showAlert("Link copiado!");

		},
		getVariantsByStatus(status) {
			let label = status;
			let variant = ""
			switch (status) {
				case "canceled":
					label = this.$t('payments.canceled')
					variant = "danger"
					break;
				case "paid":
					label = this.$t('payments.paid')
					variant = "success"
					break;
			}
			return {label, variant}
		},
		formDone() {
			this.closeFormPayment();
			this.fetchPayments();

		}
	},
	mounted: function () {
		this.fetchPayments()
	},
	computed: {
		...mapState("reservation", ["viewModel"]),
		itemsPayments() {
			let items = [];
			this.payments.forEach(payment => {
				let item = {...payment};
				let {label, variant} = this.getVariantsByStatus(payment.status);
				item._rowVariant = variant;
				item.statusLabel = label;

				items.push(item)

			})
			return items
		}
	},

}
</script>
